module.exports = __webpack_public_path__ + "static/media/Uplands Road N8 (5).0fa060e6.JPG";